/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDividendDto } from '../../models/backend-venture-fund-dividend-dto';
import { BackendVentureFundDividendRequestDto } from '../../models/backend-venture-fund-dividend-request-dto';

export interface VentureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Params {
  body: BackendVentureFundDividendRequestDto;
}

export function ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDividendDto>;
    }),
  );
}

ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded.PATH = '/api/venture_funds/venture-fund-dividends/';
